/* Zydonia Redesign im Craft-Theme: gemeinsame Logik der zyx-Abschnitte.
   Einblendungen, Nacht/Tag-Schalter (schwebend, nur solange Redesign-Abschnitte sichtbar sind),
   Rückmeldungen und "In den Warenkorb" (übergibt an den Warenkorb des Live-Themes, z. B. Kaching Cart). */
(function () {
  const D = window.ZY;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hasGSAP = !!(window.gsap && window.ScrollTrigger);
  const html = document.documentElement;
  if (hasGSAP) window.gsap.registerPlugin(window.ScrollTrigger);
  if (reduce || !hasGSAP) { html.classList.remove('zy-motion'); html.classList.add('zy-no-motion'); }

  // Ebene für schwebende Elemente (Schalter, Rückmeldung, fliegender Flakon), damit das Redesign-CSS greift
  const layer = document.createElement('div');
  layer.className = 'zyx zyx-layer';
  document.body.appendChild(layer);

  /* ---------- Nacht und Tag ---------- */
  const current = () => (html.dataset.zyTheme === 'dark' ? 'dark' : 'light');
  function themedPath(str, light) {
    return str.replace(/\/zy-(?:day-)?([a-z0-9-]+?)-(\d+)\.webp/g, (m, name, w) =>
      '/zy-' + (light && D.dayImgs.has(name) ? 'day-' : '') + `${name}-${w}.webp`);
  }
  function swapImages(light) {
    document.querySelectorAll('.zyx img[src], .zyx source[srcset]').forEach(el => {
      ['srcset', 'src'].forEach(attr => {
        const v = el.getAttribute(attr);
        if (!v || v.indexOf('/zy-') === -1) return;
        const next = themedPath(v, light);
        if (next !== v) el.setAttribute(attr, next);
      });
    });
  }
  function syncToggle() {
    const light = current() === 'light';
    document.querySelectorAll('[data-theme-toggle]').forEach(b => {
      b.setAttribute('aria-checked', String(light));
      b.setAttribute('aria-label', light ? 'Dunkles Design' : 'Helles Design');
    });
  }
  function applyTheme(next) {
    html.dataset.zyTheme = next;
    try { localStorage.setItem('zy-theme', next); } catch (e) { /* privater Modus */ }
    swapImages(next === 'light');
    syncToggle();
    window.dispatchEvent(new CustomEvent('zy:theme', { detail: next }));
  }
  function setTheme(next, originEl) {
    if (next === current()) return;
    if (reduce || !document.startViewTransition) { applyTheme(next); return; }
    const r = originEl.getBoundingClientRect();
    const x = r.left + r.width / 2, y = r.top + r.height / 2;
    const radius = Math.hypot(Math.max(x, innerWidth - x), Math.max(y, innerHeight - y));
    const vt = document.startViewTransition(() => applyTheme(next));
    vt.ready.then(() => {
      html.animate({ clipPath: [`circle(0px at ${x}px ${y}px)`, `circle(${radius}px at ${x}px ${y}px)`] },
        { duration: 1000, easing: 'cubic-bezier(.65, 0, .35, 1)', pseudoElement: '::view-transition-new(root)' });
    }).catch(() => {});
  }
  // Kleines Symbol im Header vor Suche, Konto und Warenkorb (Mond = zu Nacht wechseln, Sonne = zu Tag)
  const icons = document.querySelector('.header__icons');
  if (icons) {
    icons.insertAdjacentHTML('afterbegin', `
      <button class="header__icon zyx-hdr-theme" type="button" role="switch" aria-checked="false" title="Nacht- oder Tag-Design" data-theme-toggle>
        <i class="ph-light ph-moon" aria-hidden="true"></i><i class="ph-light ph-sun" aria-hidden="true"></i>
      </button>`);
    const toggle = icons.querySelector('[data-theme-toggle]');
    toggle.addEventListener('click', () => setTheme(current() === 'light' ? 'dark' : 'light', toggle));
  }
  /* Duft-Quiz (App RevenueHunt) zeichnet in einem Shadow-DOM: Nachtfarben dort als eigene Stilregeln einsetzen */
  const QUIZ_DARK = `.quiz, main, :host {
    --quiz-background-color: #0c0b0a !important; --question-heading-color: #f2ede5 !important; --question-text-color: #c4bcaf !important;
    --link-text-color: #e6ad62 !important; --button-background-color: #f2ede5 !important; --button-text-color: #0c0b0a !important;
    --button-background-color-hover: #e6ad62 !important; --button-text-color-hover: #0c0b0a !important;
    --choice-background-color: #1a1714 !important; --choice-text-color: #f2ede5 !important;
    --choice-selected-background-color: #2a2520 !important; --choice-selected-text-color: #f2ede5 !important; --choice-selected-icon-color: #e6ad62 !important;
    --input-background-color: #12100e !important; --input-border-color: rgba(242,237,229,.3) !important; --input-text-color: #f2ede5 !important; --input-placeholder-color: rgba(242,237,229,.45) !important;
    --dropdown-selected-background-color: #2a2520 !important; --dropdown-selected-text-color: #f2ede5 !important;
    --navigation-background-color: #0c0b0a !important; --navigation-text-color: #f2ede5 !important; --navigation-border-color: rgba(242,237,229,.18) !important; --navigation-progress-bar-color: #e6ad62 !important;
    --product-collection-card-background-color: #12100e !important; --results-card-title-color: #f2ede5 !important; --results-card-price-color: #f2ede5 !important; --results-card-text-color: #c4bcaf !important; }
  .question-background, .question-background-image, .navigation-bar__container { background-color: #0c0b0a !important; }`;
  // Englische Knopftexte der Quiz-Ergebnisse (App-Standard) auf Deutsch, nur bei exakt passendem Text
  const QUIZ_DE = {
    'add to cart': 'In den Warenkorb legen', 'add all to cart': 'Alle in den Warenkorb legen', 'adding...': 'Wird hinzugefügt …', 'adding…': 'Wird hinzugefügt …',
    'added': 'Hinzugefügt', 'added to cart': 'Im Warenkorb', 'sold out': 'Ausverkauft', 'out of stock': 'Ausverkauft',
    'view product': 'Ansehen', 'view details': 'Ansehen', 'go to cart': 'Zum Warenkorb', 'view cart': 'Zum Warenkorb', 'checkout': 'Zur Kasse',
    'next': 'Weiter', 'next question': 'Nächste Frage', 'previous question': 'Vorherige Frage', 'answer before proceeding': 'Bitte zuerst antworten',
    'retake quiz': 'Test wiederholen', 'restart quiz': 'Test wiederholen', 'start over': 'Neu starten', 'see results': 'Ergebnis anzeigen', 'show results': 'Ergebnis anzeigen',
    'proceed to cart': 'Zum Warenkorb', 'proceed to checkout': 'Zur Kasse', 'adding': 'Wird hinzugefügt …', 'x complete': ''
  };
  // Die App zeigt für Deutsch teils nur Platzhalter wie „add_to_cart“: Unterstriche wie Leerzeichen behandeln
  const quizKey = s => s.trim().toLowerCase().replace(/_/g, ' ').replace(/\s+/g, ' ');
  function translateQuiz(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    for (let n = walker.nextNode(); n; n = walker.nextNode()) {
      if (!n.parentElement || n.parentElement.tagName === 'STYLE' || n.parentElement.tagName === 'SCRIPT') continue;
      const raw = n.nodeValue.trim();
      const de = QUIZ_DE[quizKey(raw)];
      if (de !== undefined && raw && raw !== de) n.nodeValue = n.nodeValue.replace(raw, de);
    }
    root.querySelectorAll('[aria-label], [title], input[type="submit"], input[type="button"]').forEach(el => {
      ['aria-label', 'title', 'value'].forEach(a => { const v = el.getAttribute(a); const de = v ? QUIZ_DE[quizKey(v)] : undefined; if (de) el.setAttribute(a, de); });
    });
  }
  function styleQuizzes() {
    const dark = current() === 'dark';
    document.querySelectorAll('quiz-renderer [id="shadow-quiz"], #shadow-quiz').forEach(host => {
      const root = host.shadowRoot;
      if (!root) return;
      // Ergebnisse und Knöpfe entstehen tief im Shadow-DOM: auf alle Änderungen hören (Übersetzen ändert nur, was noch englisch ist)
      if (!root.__zyxObs) { root.__zyxObs = new MutationObserver(() => { clearTimeout(root.__zyxT); root.__zyxT = setTimeout(styleQuizzes, 30); }); root.__zyxObs.observe(root, { childList: true, subtree: true, characterData: true }); }
      let st = root.getElementById('zyx-quiz-dark');
      if (dark && !st) { st = document.createElement('style'); st.id = 'zyx-quiz-dark'; st.textContent = QUIZ_DARK; root.appendChild(st); }
      if (!dark && st) st.remove();
      translateQuiz(root);
    });
  }
  if (document.querySelector('quiz-renderer')) {
    // Das Quiz lädt nach und baut sich bei jedem Schritt neu auf
    new MutationObserver(styleQuizzes).observe(document.querySelector('quiz-renderer'), { childList: true, subtree: true });
    [500, 1500, 3000, 6000].forEach(t => setTimeout(styleQuizzes, t));
  }
  window.addEventListener('zy:theme', styleQuizzes);
  swapImages(current() === 'light');
  syncToggle();

  /* ---------- Text in Wörter teilen ---------- */
  function split(el, cls) {
    const inner = cls || 'wi';
    if (el.dataset.splitDone) return el.querySelectorAll('.' + inner);
    const walk = node => {
      Array.from(node.childNodes).forEach(ch => {
        if (ch.nodeType === 3) {
          const frag = document.createDocumentFragment();
          ch.textContent.split(/(\s+)/).forEach(part => {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
            if (inner === 'wi') {
              const w = document.createElement('span'); w.className = 'w';
              const wi = document.createElement('span'); wi.className = 'wi'; wi.textContent = part;
              w.appendChild(wi); frag.appendChild(w);
            } else {
              const s = document.createElement('span'); s.className = inner; s.textContent = part; frag.appendChild(s);
            }
          });
          node.replaceChild(frag, ch);
        } else if (ch.nodeType === 1 && ch.tagName !== 'BR') walk(ch);
      });
    };
    walk(el);
    el.dataset.splitDone = '1';
    if (inner === 'wi') el.classList.add('split');
    return el.querySelectorAll('.' + inner);
  }

  /* ---------- Einblendungen beim Scrollen ---------- */
  function reveals() {
    const scope = document.querySelectorAll('.zyx');
    // Jedes Element nur einmal einrichten (zyx-site und zyx-home rufen reveals auf)
    const all = sel => Array.from(scope).flatMap(s => Array.from(s.querySelectorAll(sel))).filter(el => {
      const key = 'zyxR' + (sel.includes('split') ? 's' : 'r');
      if (el.dataset[key]) return false;
      el.dataset[key] = '1';
      return true;
    });
    if (!hasGSAP || reduce) { all('[data-reveal],[data-split]').forEach(el => { el.style.opacity = 1; }); return; }
    const { gsap } = window;
    all('[data-split]:not([data-split="manual"])').forEach(el => {
      const words = split(el);
      gsap.set(el, { opacity: 1 });
      gsap.fromTo(words, { yPercent: 115 }, { yPercent: 0, duration: 1.25, ease: 'expo.out', stagger: 0.045, scrollTrigger: { trigger: el, start: 'top 88%', once: true } });
    });
    all('[data-reveal]').forEach(el => {
      if (el.dataset.reveal === 'clip') {
        const im = el.querySelector('img, video');
        gsap.fromTo(el, { opacity: 1, clipPath: 'inset(14% 6% 14% 6%)' }, { clipPath: 'inset(0% 0% 0% 0%)', duration: 1.6, ease: 'expo.out', scrollTrigger: { trigger: el, start: 'top 85%', once: true } });
        if (im) gsap.fromTo(im, { scale: 1.18 }, { scale: 1, duration: 1.9, ease: 'expo.out', scrollTrigger: { trigger: el, start: 'top 85%', once: true } });
      } else {
        gsap.fromTo(el, { opacity: 0, y: 26 }, { opacity: 1, y: 0, duration: 1.1, ease: 'expo.out', scrollTrigger: { trigger: el, start: 'top 90%', once: true } });
      }
    });
  }

  /* ---------- Rückmeldungen ---------- */
  let toastEl = null, toastTimer = null;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      layer.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('is-on'), 2600);
  }

  // Ein kleiner Flakon fliegt vom Knopf zum Warenkorb-Symbol im Header
  function flyToCart(fromEl, imgSrc) {
    const target = document.querySelector('#cart-icon-bubble, a[href$="/cart"]');
    if (reduce || !hasGSAP || !fromEl || !target) return Promise.resolve();
    const { gsap } = window;
    const a = fromEl.getBoundingClientRect(), b = target.getBoundingClientRect();
    const f = document.createElement('div');
    f.className = 'fly';
    f.innerHTML = `<img src="${imgSrc}" alt="">`;
    layer.appendChild(f);
    gsap.set(f, { x: a.left + a.width / 2 - 32, y: a.top + a.height / 2 - 40, scale: .5, opacity: 0, rotate: -6 });
    return new Promise(resolve => {
      gsap.timeline({ onComplete: () => { f.remove(); resolve(); } })
        .to(f, { opacity: 1, scale: 1, rotate: 0, duration: .22, ease: 'power2.out' })
        .to(f, { x: b.left + b.width / 2 - 32, duration: .7, ease: 'power3.inOut' }, .12)
        .to(f, { y: b.top + b.height / 2 - 40, duration: .7, ease: 'back.in(1.4)' }, .12)
        .to(f, { scale: .2, opacity: 0, duration: .22, ease: 'power2.in' }, .64);
    });
  }

  /* ---------- In den Warenkorb (Warenkorb des Live-Themes) ---------- */
  async function addToCart(items, fromEl, imgSrc) {
    items = items.filter(i => i && i.id);
    if (!items.length) { toast('Dieser Artikel ist gerade nicht verfügbar.'); return; }
    const flight = flyToCart(fromEl, imgSrc);
    try {
      // window.fetch: Kaching Cart und der Geschenk-Schutz hängen sich hier ein und öffnen bzw. prüfen den Warenkorb
      const res = await fetch((D.routes.root || '/').replace(/\/$/, '') + '/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items.map(i => ({ id: Number(i.id), quantity: i.quantity || 1 })) })
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.description || 'Das hat leider nicht geklappt.');
      await flight;
      // Kaching Cart öffnet sich beim Hinzufügen von selbst; ohne Kaching zur Warenkorb-Seite
      const api = window.kachingCartApi;
      if (api && typeof api.openCart === 'function') {
        if (typeof api.refreshCart === 'function') api.refreshCart();
        api.openCart();
      } else {
        window.location.href = D.routes.cart || '/cart';
      }
    } catch (err) {
      await flight;
      toast(err.message || 'Das hat leider nicht geklappt.');
    }
  }

  /* ---------- Bewertungs-Laufband: läuft von selbst, lässt sich aber wischen und ziehen (mit Schwung) ---------- */
  // Statt CSS-Animation ein scrollbarer Streifen, der per requestAnimationFrame weiterrückt. Fasst man ihn an,
  // pausiert er und läuft 2,5 s nach dem Loslassen weiter. Der Inhalt liegt doppelt vor, daher Endlosschleife über die halbe Breite.
  // Nur für Laufbänder mit data-swipe (Loox-Fotobewertungen); die übrigen laufen wie bisher als CSS-Animation.
  document.querySelectorAll('.zyx .marquee').forEach(box => {
    const track = box.querySelector('[data-marquee][data-swipe]');
    if (!track) return;
    box.classList.add('is-scroll');
    const secs = parseFloat(track.style.animationDuration) || 70;
    let pos = 0, expected = 0, pausedUntil = 0, hover = false, visible = false, last = 0;
    const half = () => track.scrollWidth / 2;
    const hold = ms => { pausedUntil = performance.now() + ms; };
    box.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') hover = true; });
    box.addEventListener('pointerleave', () => { hover = false; });
    box.addEventListener('pointerdown', () => hold(2500));
    box.addEventListener('touchstart', () => hold(2500), { passive: true });
    box.addEventListener('scroll', () => {
      // Eigene Bewegung (Bruchteile eines Pixels bleiben in pos erhalten) oder Wischen? Wischen: anhalten, Position übernehmen
      if (Math.abs(box.scrollLeft - expected) <= 2) return;
      hold(2500);
      const h = half();
      if (h > 0 && box.scrollLeft >= h) box.scrollLeft -= h;
      else if (h > 0 && box.scrollLeft <= 0) box.scrollLeft += h;
      pos = expected = box.scrollLeft;
    }, { passive: true });
    new IntersectionObserver(es => { visible = es[0].isIntersecting; }).observe(box);
    if (reduce) return;
    const tick = t => {
      const dt = last ? Math.min(t - last, 64) : 16;
      last = t;
      if (visible && !hover && t > pausedUntil && !box.classList.contains('is-dragging')) {
        const h = half();
        if (h > 0) {
          pos += (h / secs) * dt / 1000;
          if (pos >= h) pos -= h;
          box.scrollLeft = pos;
          expected = box.scrollLeft;
        }
      }
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  });

  /* ---------- Reihen mit der Maus ziehen (Touch wischt ohnehin) ---------- */
  const DRAG_SEL = '.pfch__panels, .xsell__track, .zyx-fav__grid, .rail__track, .marquee.is-scroll';
  let drag = null;
  document.addEventListener('pointerdown', e => {
    if (e.pointerType === 'touch' || e.button !== 0) return;
    const el = e.target.closest(DRAG_SEL);
    if (!el || el.scrollWidth <= el.clientWidth + 2) return;
    drag = { el, x0: e.clientX, left0: el.scrollLeft, moved: false, lastX: e.clientX, lastT: performance.now(), vel: 0 };
  });
  window.addEventListener('pointermove', e => {
    if (!drag) return;
    const dx = e.clientX - drag.x0;
    if (!drag.moved) { if (Math.abs(dx) < 6) return; drag.moved = true; drag.el.classList.add('is-dragging'); }
    const now = performance.now();
    drag.vel = (e.clientX - drag.lastX) / Math.max(1, now - drag.lastT);
    drag.lastX = e.clientX; drag.lastT = now;
    drag.el.scrollLeft = drag.left0 - dx;
  });
  const endDrag = () => {
    if (!drag) return;
    const d = drag; drag = null;
    if (!d.moved) return;
    d.el.classList.remove('is-dragging');
    // Klick direkt nach dem Ziehen nicht als Klick werten
    const block = ev => { ev.preventDefault(); ev.stopPropagation(); };
    d.el.addEventListener('click', block, { capture: true, once: true });
    setTimeout(() => d.el.removeEventListener('click', block, { capture: true }), 0);
    d.el.scrollTo({ left: d.el.scrollLeft - d.vel * 260, behavior: reduce ? 'auto' : 'smooth' });
  };
  window.addEventListener('pointerup', endDrag);
  window.addEventListener('pointercancel', endDrag);
  document.addEventListener('dragstart', e => { if (e.target.closest && e.target.closest(DRAG_SEL)) e.preventDefault(); });

  window.ZYSite = { reduce, hasGSAP, split, reveals, toast, flyToCart, setTheme, currentTheme: current, ready: Promise.resolve(), lenis: null };
  // Redesign-Abschnitte außerhalb der Startseite (z. B. Parfum-Seite) einblenden; die Startseite ruft es nach dem Aufbau erneut auf
  reveals();
  window.ZYCart = { add: addToCart };
})();
